import api from './api';

const activityService = {
  /**
   * Get activity statistics
   * @param {number} days - Number of days to fetch data for
   * @returns {Promise<object>}
   */
  getStats: async (days = 30) => {
    const response = await api.get('/activity/stats', { params: { days } });
    if (response.success && response.data) {
      return response.data;
    }
    throw new Error(response.error?.message || 'Failed to fetch activity stats');
  },
};

export default activityService;
